import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue, sumArray } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const AdsToSitePage: React.FC = () => {
  const adsToSite = analyticsSnapshot.crossChannelAnalysis.adsToSite;
  const clicksDataset = adsToSite.datasets.find((dataset) => dataset.label === 'AdClicks') ?? adsToSite.datasets[0];
  const revenueDataset =
    adsToSite.datasets.find((dataset) => dataset.label === 'AdRevenue') ?? adsToSite.datasets.at(-1);
  const latestClicks = findLatestValue(clicksDataset?.data ?? []);
  const latestRevenue = revenueDataset ? findLatestValue(revenueDataset.data) : { value: null, index: -1 };
  const latestLabel = latestClicks.index >= 0 ? adsToSite.labels[latestClicks.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.crossChannelAnalysis.adsToSite.insights;
  const chartData = useMemo<ChartData<'bar'>>(
    () => ({
      labels: Array.from(adsToSite.labels),
      datasets: adsToSite.datasets.map((dataset) => ({
        label: dataset.label === 'AdRevenue' ? 'Gelir (USD)' : 'Tıklama',
        data: Array.from(dataset.data)
      }))
    }),
    [adsToSite.labels, adsToSite.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Reklamdan Siteye Dönüş</h1>
          <p className="text-white/70 mt-2">
            Reklam tıklamaları ve gelir katkısı ile kampanyaların site trafiğine etkisini ölçün.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{latestLabel}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricSummary title="Toplam Tıklama" value={sumArray(clicksDataset.data)} description="Yıllık toplam klik." />
        <MetricSummary
          title="Toplam Reklam Geliri"
          value={revenueDataset ? sumArray(revenueDataset.data) : null}
          unit="currency"
          currency="USD"
          description="Reklam yönlendirmelerinden elde edilen gelir."
        />
        <MetricSummary title="Son Ay Tıklama" value={latestClicks.value} description="Son ölçülen dönem." />
      </div>

      <ChartCard
        title="Aylık Reklamdan Siteye Akış"
        description="Reklam tıklamaları ve gelir katkısını takip edin."
        data={chartData}
        chartType="bar"
        insights={insights}
      />

    </div>
  );
};

export default AdsToSitePage;

